import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-book",
  "use": "icon-book-usage",
  "viewBox": "0 0 40 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 48\" id=\"icon-book\">\r\n  <path id=\"icon-book_book\" d=\"M42,48H8a6,6,0,0,1-6-6V6A6,6,0,0,1,8,0H42Zm-4-8H8.99a2,2,0,1,0,0,4H38ZM38,4H8V36H38Zm-6,6v6H14V10Z\" transform=\"translate(-2)\" fill=\"currentColor\" fill-rule=\"evenodd\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol